export default __webpack_public_path__ + "71730566d6c47ffdc965f106b22ba814.svg";